// extracted by mini-css-extract-plugin
export var categoryFilter = "CategoryFilter-module--category-filter--xtG4f";
export var categoryFilterBlurb = "CategoryFilter-module--category-filter-blurb--bUtFU";
export var categoryFilterBlurbIcon = "CategoryFilter-module--category-filter-blurb-icon--QJjYa";
export var categoryFilterBlurbTitle = "CategoryFilter-module--category-filter-blurb-title--LqJY7";
export var categoryFilterInner = "CategoryFilter-module--category-filter-inner--MCE5+";
export var categoryFilterItem = "CategoryFilter-module--category-filter-item--FF2dU";